module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray-3b72319bc4d1df1e8e8ed27618996efc.png";